import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import {registerLocaleData} from '@angular/common';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {ToastModule} from 'primeng/toast';
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CustomTranslateLoader} from './providers/translate-loader/CustomTranslateLoader';
import {IntercomModule} from 'ng-intercom';
import {EdwMissingTranslationHandler, EdwToolsLocaleService} from '@edward-software/edw-fwk-angular-lib/providers';
import {EdwFwkAngularLibModule} from '@edward-software/edw-fwk-angular-lib/api';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {environment} from '../environments/environment';


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ToastModule,
        RouterModule,
        EdwFwkAngularLibModule.forRoot(environment),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: {provide: MissingTranslationHandler, useClass: EdwMissingTranslationHandler}
        }),
        IntercomModule.forRoot({
            appId: 'INITIALIZED',
            updateOnRouterChange: true
        }),
        HttpClientModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule
    ],
    providers: [
        {
            provide: LOCALE_ID,
            deps: [EdwToolsLocaleService],
            useFactory: (LocaleService: { locale: string }) => LocaleService.locale
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

registerLocaleData(localeEn);
registerLocaleData(localeFr);
